import ReactMarkdown from 'react-markdown';
import { Checkbox, Label } from '@design-system';
import type { ConsentItem } from '@shared/consents';

interface ApplicationConsentsProps {
  items: ConsentItem[];
  accepted: Record<string, boolean>;
  onChange: (consentId: string, isAccepted: boolean) => void;
}

/** The quote-and-apply consents, each with its full wording and a box to accept it. */
export function ApplicationConsents({ items, accepted, onChange }: ApplicationConsentsProps) {
  return (
    <section aria-label="Your consents" className="flex flex-col gap-3" data-testid="consumer-application-consents">
      <div className="flex flex-col gap-1">
        <h2 className="text-base font-semibold text-gray-950">Your consents</h2>
        <p className="text-muted-foreground text-sm">Please read and accept each one to send your application.</p>
      </div>
      {items.map(item => (
        <div key={item.id} className="flex flex-col gap-3 rounded-xl border bg-white p-4">
          <strong className="text-sm text-gray-950">{item.title}</strong>
          <div className="text-muted-foreground flex flex-col gap-2 text-sm [&_ul]:list-disc [&_ul]:pl-5">
            <ReactMarkdown>{item.formattedDescription?.trim() || item.description}</ReactMarkdown>
          </div>
          <div className="flex items-start gap-3">
            <Checkbox
              id={`consent-${item.id}`}
              checked={!!accepted[item.id]}
              onCheckedChange={checked => onChange(item.id, checked === true)}
            />
            <Label htmlFor={`consent-${item.id}`} className="font-normal leading-snug">
              {item.checkbox}
            </Label>
          </div>
        </div>
      ))}
    </section>
  );
}
